export default __webpack_public_path__ + "static/media/solar_battery.f68372d0.svg";